import {
  LOADING,
  ALERTS_LOADED,
  ALERT_TAB_SWITCHED,
} from '../actions/constants';
import AlertRef, { ZAPIER } from '../util/AlertRef';

const INITIAL_STATE = {
  all: null, // list of AlertRef objs
  zapierApiKey: null, // zapier api key
  activeTab: ZAPIER, // default to email until zapier is live for everybody
};

const Alerts = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      if (action.awaiting === ALERTS_LOADED) {
        return {
          ...state,
          all: null, // reset
        };
      }
      return state;
    }
    case ALERT_TAB_SWITCHED: {
      return { ...state, activeTab: action.payload.tabName };
    }
    case ALERTS_LOADED: {
      return {
        ...state,
        zapierApiKey: action.payload.json._zapierApiKey,
        all: action.payload.json._alerts
          .map((a) => AlertRef.build(a))
          .sort((a1, a2) => a1.name().localeCompare(a2.name())),
      };
    }
    default:
      return state;
  }
};

export default Alerts;
